// extracted by mini-css-extract-plugin
export default {"UpCominBanner":"UpcomingOffer_UpCominBanner__3fS1e","DayInner":"UpcomingOffer_DayInner__bWk-D","BookBtn":"UpcomingOffer_BookBtn__5Py2N"};